import Vue from 'vue'
import Vuex from 'vuex'
import {useSessionStorage} from "@vueuse/core";
import {v4 as uuid} from "uuid";

Vue.use(Vuex)

const sessionId = useSessionStorage('samk-chat-session-id', uuid(), {mergeDefaults: true});
const store = new Vuex.Store({
  state: {
    count: 0,
    sessionId: sessionId.value,
    wizardStep: 1
  },
  mutations: {
    increment (state) {
      state.count++
    },
    setSessionId (state, sessionId) {
      state.sessionId = sessionId;
    },
    setWizardStep (state, step) {
      state.wizardStep = step;
    }
  }
})

export default store;
